export const listExpectedStatuses = (statusCollection: string[]) =>
  statusCollection.join(', ');



// WEBPACK FOOTER //
// ./src/shared/helpers/api/listExpectedStatuses.ts